module.exports = __webpack_public_path__ + "statics/img/5.7db8160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/5.jpg
// module id = 82lR
// module chunks = 1